import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { PublicBoxQuestionnaireFileResponse } from './public-box-questionnaire-file.response';
import { PublicBoxQuestionnaireQuestionOptionAttributeResponse } from './public-box-questionnaire-question-option-attribute.response';
import { PublicBoxQuestionnaireQuestionOptionSourceResponse } from './public-box-questionnaire-question-option-source.response';

@jsonObject
export class PublicBoxQuestionnaireQuestionOptionResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Boolean)
  public readonly isSelected!: boolean;

  @jsonMember(Boolean)
  public readonly isAutoSelected?: Nillable<boolean>;

  @jsonMember(Boolean)
  public readonly isAvailable!: boolean;

  @jsonMember(PublicBoxQuestionnaireFileResponse)
  public readonly featureFile?: Nillable<PublicBoxQuestionnaireFileResponse>;

  @jsonMember(PublicBoxQuestionnaireQuestionOptionSourceResponse)
  public readonly source?: Nillable<PublicBoxQuestionnaireQuestionOptionSourceResponse>;

  @jsonArrayMember(PublicBoxQuestionnaireQuestionOptionAttributeResponse)
  public readonly attributes?: PublicBoxQuestionnaireQuestionOptionAttributeResponse[];
}
